import AddIcon from "@mui/icons-material/Add";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import { Card, Typography, Zoom } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Lightbox } from "react-modal-image";
import { Document, Page, pdfjs } from "react-pdf";
import ReactPlayer from "react-player";
import { v4 as uuidv4 } from "uuid";
import DocsAccordian from "./DocsAccordian";
import UploadAttachmentModal from "../../../../components/UploadAttachmentModal";
import { DownloadDone } from "@mui/icons-material";
import mimee from "mime";
import i18n from "i18n/i18n";
import { Link, useNavigate } from "react-router-dom";
import { useBoundStore } from "store/store";

import CardButton from "components/CardButton";
import { categoryItems, docs_enum, getFileExtention, images_enum, videos_enum } from "utils/helper";
import DragAndDropAccordian from "./DragAndDropAccordian";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var video_key = 0;

function DocumentationTab(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  const { machineData } = props;
  const navigate = useNavigate();
  const isLoggedIn = useBoundStore((state) => state.isLoggedIn);
  const createAttachment = useBoundStore((state) => state.createAttachment);
  const loadEquipmentDetails = useBoundStore(
    (state) => state.loadEquipmentDetails
  );

  const [target, setTarget] = useState();
  const [category, setCategory] = useState("");

  const [showButtn, setShowButton] = useState(true); // to avoid double click

  const [numPages, setnumPages] = useState(null);
  const [pageNumber, setpageNumber] = useState(1);
  const [isOpenPDF, setisOpenPDF] = useState(false);
  const [large, setlarge] = useState("");
  const [openDialog, setopenDialog] = useState(false);
  const [openDialogVideo, setopenDialogVideo] = useState(false);
  const [nextDisabled, setnextDisabled] = useState(false);
  const [prevDisabled, setprevDisabled] = useState(true);
  const [pdfLink, setpdfLink] = useState("");
  const [titleManu, settitleManu] = useState("");
  const [titleInternal, settitleInternal] = useState("");
  const [description, setdescription] = useState("");
  const [videoUrl, setvideoUrl] = useState();
  const [attachmentCategory, setAttachmentCategory] = useState("");

  const [UploadDialog, setUploadDialog] = useState(false);
  const [fileid, setfileid] = useState("");
  const [uploadUrl, setuploadUrl] = useState();
  const [bucketid, setbucketid] = useState();
  const [Newfile, setNewfile] = useState();
  const [fileVersion, setFileVersion] = useState("");

  const [UploadDialogInternal, setUploadDialogInternal] = useState(false);
  const [fileidInternal, setfileidInternal] = useState("");
  const [uploadUrlInternal, setuploadUrlInternal] = useState("");
  const [bucketidInternal, setbucketidInternal] = useState("");
  const [NewfileInternal, setNewfileInternal] = useState<File | null>(null);

  const [fileVersionInternal, setFileVersionInternal] = useState("");

  const [descriptionInternal, setdescriptionInternal] = useState("");
  const [values, setValues] = useState({
    showPassword: false,
  });

  // Check if NewfileInternal is not null before creating a new File object
  var file = NewfileInternal
    ? new File([NewfileInternal], NewfileInternal.name, {
        type: NewfileInternal.type,
      })
    : null;

  var localURL = file ? URL.createObjectURL(file) : null;

  const onDocumentLoadSuccess = (totalPages: any) => {
    setnumPages(totalPages);
    if (totalPages == 1) {
      setnextDisabled(true);
    }
  };
  const handleCloseDialog = () => {
    setopenDialog(false);
  };
  const handleCloseDialogVideo = () => {
    setopenDialogVideo(false);
  };
  const handleNextPage = () => {
    setpageNumber(pageNumber + 1);
    if (pageNumber > 0) {
      setprevDisabled(false);
    }
    if (pageNumber == Number(numPages) - 1) {
      setnextDisabled(true);
    }
  };

  const handlePrevPage = () => {
    setpageNumber(pageNumber - 1);
    if (pageNumber > 1) {
      setnextDisabled(false);
    }
    if (pageNumber == 2) {
      setprevDisabled(true);
    }
  };
  const handleClickOpen = () => {
    setUploadDialog(true);
  };

  const handleClose = () => {
    setfileid("");
    setUploadDialog(false);
  };
  const handleClickOpenInternal = () => {
    setfileidInternal("");
    setUploadDialogInternal(true);
  };

  const handleCloseInternal = () => {
    settitleInternal("");
    setdescriptionInternal("");
    setNewfileInternal(null);
    setUploadDialogInternal(false);
    setCategory("");
  };

  const createGenericAttachment = async () => {
    const attachment = {
      attachment: {
        description: null,
        file: {
          localuri: localURL,
          mimetype: NewfileInternal?.type,
        },
      },
    };

    let file = [];
    file.push(attachment);

    const obj: any = {};
    obj["title"] =
      titleInternal === ""
        ? NewfileInternal?.name.split(".")[0]
        : titleInternal;
    obj["description"] = descriptionInternal;
    obj["lang"] = lang;
    obj["isattachmentof"] = machineData?.equipment?.nodeid
      ? machineData?.equipment?.nodeid
      : "";
    obj["attachments"] = file;
    obj["specifier"] = attachmentCategory;

    const promises: any[] = [
      createAttachment(
        obj,
        machineData?.equipment?.nodeid ? machineData?.equipment?.nodeid : ""
      ),
    ]; // Ensure that promises is an array

    if (isLoggedIn === true) {
      try {
        const result = await Promise.all(promises);

        setTimeout(() => {
          setAttachmentCategory("");
          loadEquipmentDetails(machineData?.equipment?.nodeid, lang);
        }, 2000);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }

    settitleInternal("");
    setdescriptionInternal("");
    setNewfileInternal(null);
    setUploadDialogInternal(false);
    setCategory("");
  };

  const showPDF = (link: any) => {
    setopenDialog(true);
    setpdfLink(link);
    setnumPages(null);
    setpageNumber(1);
    setprevDisabled(true);
    setnextDisabled(false);
  };

  const [AttachmentInternal, setAttachmentInternal] = useState<Array<any>>([]);
  const [AttachmentManufacturer, setAttachmentManufacturer] = useState<
    Array<any>
  >([]);

  useEffect(() => {
    if (machineData.equipment != undefined) {
      var tempArr: any = [];
      var tempArr1: any = [];
      if (machineData.equipment.hasattachment != undefined) {
        machineData.equipment.hasattachment.forEach((x: any, k: any) => {
          if (x.attachment.file != null) {
            const obj = {
              nodeid: x.attachment.nodeid,
              title: x.attachment.title,
              description: x.attachment.description,
              url: x.attachment.file.url,
              fileid: x.attachment.file.fileid,
              mimetype: x.attachment.file.mimetype,
              specifier: x.attachment.specifier,
              file: x.attachment.file,
            };
            tempArr.push(obj);
          }
        });
      }
      setAttachmentInternal(tempArr);
      setAttachmentManufacturer(tempArr1);
    }
  }, [machineData]);

  const [AttachmentNodeid, setAttachmentNodeid] = useState();
  const showVIDEO = (link: any) => {
    setvideoUrl(link);
    setopenDialogVideo(true);
  };

  return (
    <div className={"documentationContainer"}>
      {isOpenPDF && (
        <Lightbox
          large={large}
          alt={i18n(lang)?.image_here}
          hideZoom={false}
          showRotate={true}
          small=""
        />
      )}
      <div className={`docsHeader`}>
        <div className="generalHeading">
          {i18n(lang)?.heading_documentation}
        </div>

        <Grid item xs={4}>
         
          <Button
            variant="contained"
            style={{
              backgroundColor: "var(--primary-color)",
              letterSpacing: 1.25,
            }}
            size="small"
            
            startIcon={<AddIcon />}
            onClick={handleClickOpenInternal}
          >
            {i18n(lang)?.upload_file}
          </Button>
        </Grid>
      </div>

     

      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
          marginLeft: "0px",
          width: "100%",
          gap: "20px",
        }}
      >
        {categoryItems.map((item:any, index:any) => (
          <DragAndDropAccordian
            item={item}
            handleClickOpenInternal={handleClickOpenInternal}
            setAttachmentCategory={setAttachmentCategory}
            attachmentCategory={attachmentCategory}
            machines={{equipment: machineData?.equipment}}
          />
        ))}
      </Grid>

      <Dialog
        open={openDialogVideo}
        onClose={() => {
          handleCloseDialogVideo();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ backdropFilter: "blur(4px)" }}
      >
        <DialogContent>
          <ReactPlayer
            url={videoUrl}
            controls={true}
            width="500px"
            height="500px"
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={() => {
          handleCloseDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ backdropFilter: "blur(4px)" }}
        TransitionComponent={Zoom}
      >
        <DialogTitle id="alert-dialog-title">
          {"PDF" + i18n(lang)?.single_document}
        </DialogTitle>
        <DialogContent>
          <a href={pdfLink} target="_blank">
            {i18n(lang)?.download}
          </a>
          <br></br>
          <Document
            file={pdfLink}
            onLoadSuccess={(pdf: any) => {
              onDocumentLoadSuccess(pdf.numPages);
            }}
            
          >
            <Page pageNumber={pageNumber} />
            <div>
              <Button
                onClick={() => {
                  handlePrevPage();
                }}
                style={{ float: "left" }}
                color="primary"
                disabled={prevDisabled}
              >
                {i18n(lang)?.previous}
              </Button>
              <text
                style={{
                  marginLeft: "90px",
                  marginTop: "10px",
                }}
              >
                {i18n(lang)?.page} {pageNumber} {i18n(lang)?.ofPage} {numPages}
              </text>
              <Button
                onClick={() => {
                  handleNextPage();
                }}
                style={{ float: "right" }}
                color="primary"
                disabled={nextDisabled}
              >
                {i18n(lang)?.next}
              </Button>
            </div>
          </Document>
        </DialogContent>
      </Dialog>

      <UploadAttachmentModal
        hasTitle
        fromDoc
        showHeader
        hasDescription
        hasCategory={true}
        open={UploadDialogInternal}
        allowedExts={docs_enum+","+images_enum+","+videos_enum}
        onClose={handleCloseInternal}
        
        file={NewfileInternal}
        setFile={setNewfileInternal}
        
        handleSubmit={createGenericAttachment}
        description={descriptionInternal}
        setDescription={setdescriptionInternal}
        category={category}
        setCategory={setCategory}
        title={titleInternal}
        setTitle={settitleInternal}
        setTarget={setTarget}
        target={target}
        showButtn={showButtn}
        setAttachmentCategory={setAttachmentCategory}
        attachmentCategory={attachmentCategory}
        showActions
      />
    </div>
  );
}

export default DocumentationTab;
